import { Skeleton } from "@nextui-org/react";

const ModelSkeleton = () => {
  return (
    <div>
      <div className="hidden sm:block">
        <div className="flex -mx-2">
          <div className="w-[100%] px-1">
            <Skeleton className="mb-[8px] h-[180px] w-full rounded-2xl" />
            <Skeleton className="mb-[8px] h-[320px] w-full rounded-2xl" />
            <Skeleton className="mb-[8px] h-[220px] w-full rounded-2xl" />
            <Skeleton className="mb-[8px] h-[160px] w-full rounded-2xl" />
            <Skeleton className="mb-[8px] h-[220px] w-full rounded-2xl" />
          </div>
        </div>
      </div>
      <div className="sm:hidden">
        <div className="flex -mx-2">
          <div className="w-[20%] px-[6px] xl:hidden">
            <Skeleton className="mb-[12px] h-[270px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[240px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[250px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[240px] w-full rounded-2xl" />
          </div>
          <div className="w-[20%] px-[6px] xl:w-[50%] md:w-[100%]">
            <Skeleton className="mb-[12px] h-[320px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[200px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[320px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[260px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[200px] w-full rounded-2xl" />
          </div>
          <div className="w-[20%] px-[6px] xl:hidden">
            <Skeleton className="mb-[12px] h-[200px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[240px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[200px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[240px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[240px] w-full rounded-2xl" />
          </div>
          <div className="w-[20%] px-[6px] xl:w-[50%] md:hidden">
            <Skeleton className="mb-[12px] h-[240px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[260px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[240px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[280px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[260px] w-full rounded-2xl" />
          </div>
          <div className="w-[20%] px-[6px] xl:hidden">
            <Skeleton className="mb-[12px] h-[280px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[260px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[290px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[260px] w-full rounded-2xl" />
            <Skeleton className="mb-[12px] h-[260px] w-full rounded-2xl" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModelSkeleton;